import { theme } from '@/styles';
import ContentsButton from '@/ui/ContentsButton';
import Image from '@/ui/Image';
import { getAsset } from '@/utils';
import { CI } from '@design-system/pc';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';

const NotExistsContent = () => {
  const router = useRouter();
  const { returnUrl } = router.query;
  return (
    <ErrorContainer>
      <LogoIconBox>
        <CI variant="CI_symbol_primary" resize width={121} height={30} />
      </LogoIconBox>
      <BangIconBox>
        <Image
          src={getAsset('/assets/icons/ic_empty_72.svg')}
          width="72px"
          height="72px"
          alt="errorBangIcon"
        />
      </BangIconBox>
      <ErrorTitle>존재하지 않는 컨텐츠입니다.</ErrorTitle>
      <BtnLayout>
        <ContentsButton
          size="bold"
          emphasis="low"
          width="100%"
          onClick={() =>
            returnUrl ? router.replace(returnUrl as string) : router.back()
          }
        >
          이전 페이지
        </ContentsButton>
      </BtnLayout>
    </ErrorContainer>
  );
};

export default NotExistsContent;

const ErrorContainer = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  padding-top: 160px;
`;

const LogoIconBox = styled.div`
  margin-bottom: 120px;
`;

const BangIconBox = styled.div`
  margin-bottom: 24px;
`;

const ErrorTitle = styled.div`
  color: ${theme.colors.accent_colors.primary.default};
  margin-bottom: 80px;
  ${theme.typography.subtitle2};
`;

const BtnLayout = styled.div`
  display: flex;
  max-width: 570px;
  align-items: center;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;
